<template>
  <!-- <div class="container list-group-item-warning px-0 mb-2" style="height:60px;max-height:100px;">
      <div class="mh-100 vh-100 overflow-auto border border-2 rounded p-0 ms-3"> -->
  <div class="container list-group-item-warning px-0 mb-2" style="" :hidden="!bShowHide">
      <div class="border border-2 rounded p-0 ms-3">
          <div class="container-fluid rounded p-1" style="background:LemonChiffon;">
              <div class="table-responsive">
                  <table id="myROReqClinicTable" class="table table-sm table-hover table-striped" style="width: 100%;font-size:80%;">
                      <thead class="text-secondary mt-1" style="background:Gainsboro; font-size:80%;">
                      <tr>
                          <th>No.</th>
                          <th>วันที่</th>
                          <th>คนไข้</th>
                          <th title="ใบสั่งตรวจถูกยกเลิก">C</th>
                          <th title="ประเภทลูกค้าชำระเป็นเงินสด/หรือให้เครดิต">ประเภท</th>
                          <th title="P-ชำระเงินแล้ว">P</th>
                          <th>ใบสั่งตรวจ</th>
                          <th>Test</th>
                          <th>จำนวนเงิน</th>
                          <th>ส่วนลด</th>
                          <th>VAT</th>
                          <th>สุทธิ</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in datalistsROInReqClinic" :key="item.ROID" class="">
                          <!-- id และ ValueType : สำหรับใช้เป็น key ในการบันทึกผลและแยกประเภทข้อมูลแต่ละเทส -->
                          <td class="text-center py-1" style="width:15px;">{{ index + 1 }} </td>
                          <td class="text-start py-1" style="width:150px;">{{ item.DocDate }} {{ item.DocTime }} </td>
                          <td class="text-start py-1" style="width:220px;"><b>{{ item.PatName }} {{ item.PatLName }}</b> </td>
                          <td class="text-center py-1" style="width:20px;"><span class="text-danger">{{ arrCancel[item.Cancel] }}</span> </td>
                          <td class="text-center py-1" style="width:20px;"><span class="text-dark">{{ arrPayType[item.PayType] }}</span> </td>
                          <td class="text-center py-1" style="width:20px;"><span class="text-primary"><b>{{ arrPaid[item.Paid] }}</b></span> </td>
                          <td class="text-start py-1" style="width:130px;">{{ item.RONo }}
                              <span class="mx-1">{{ arrDocStatus[item.Status] }}</span>
                          </td>
                          <td class="text-start py-1">{{ item.Test }} {{ item.TestInPropack }} </td>
                          <td class="text-end py-1">{{ numeralFormat(item.TotalAmt, '0,0[.]00') }} </td>
                          <td class="text-end py-1">{{ numeralFormat(item.DiscAmt, '0,0[.]00') }} </td>
                          <td class="text-end py-1">{{ numeralFormat(item.VatAmt, '0,0[.]00') }} </td>
                          <td class="text-end py-1">{{ numeralFormat(item.NetAmt, '0,0[.]00') }} </td>
                      </tr>
                      </tbody>
                  </table>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

// import JsBarcode from 'jsbarcode/bin/JsBarcode'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  masks: {
    input: 'YYYY-MM-DD'
  },
  name: 'RepDshROClinic',
  components: {

  },
  data () {
    return {
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],
      arrCancel: ['', 'C'],
      arrPaid: ['', 'P'],

      datalistsROInReqClinic: []
    }
  },
  computed: {
    // a computed getter
  },
  created () {
    // Initial Value
    this.getData_ROInReqClinic()
  },
  props: ['bShowHide', 'curRecordReqClinic', 'docDateFm', 'docDateTo', 'BranchID', 'Status0', 'Status1', 'Status2', 'Status3'],
  mounted () {
  },
  methods: {
    toggleShowHideROInClinic () {
      this.toggleShowHide = !this.toggleShowHide
    },
    getData_ROInReqClinic () {
    //   var docDateFm = this.dateFm.toISOString().slice(0, 10)
    //   var docDateTo = this.dateTo.toISOString().slice(0, 10)
    //   var BranchID = this.branchSelected.BranchID // this.branchID
    //   var Status0 = -1 // 0-New
    //   var Status1 = -1 // 1-Lab
    //   var Status2 = -1 // 2-Resulted
    //   var Status3 = -1 // 3-Approve
    //   if (this.status0New) {
    //     Status0 = 0 // 0-New
    //   }
    //   if (this.status1Lab) {
    //     Status1 = 1 // 1-Lab
    //   }
    //   if (this.status2Res) {
    //     Status2 = 2 // 2-Resulted
    //   }
    //   if (this.status3App) {
    //     Status3 = 3 // 3-Approve
    //   }
      MyApiClient.get('getdata/repdsh_ro_where_clinic.php?C1=' + this.globalCorpID + '&BranchID=' + this.BranchID +
        '&DocDateFm=' + this.docDateFm + '&DocDateTo=' + this.docDateTo +
        '&Status0=' + this.Status0 + '&Status1=' + this.Status1 + '&Status2=' + this.Status2 +
        '&Status3=' + this.Status3 + '&ReqClinicID=' + this.curRecordReqClinic.ReqClinicID)
        .then((resp) => {
          // console.log('getdata/repdsh_ro_where_clinic.php?C1=' + this.globalCorpID + '&BranchID=' + this.BranchID +
          //   '&DocDateFm=' + this.docDateFm + '&DocDateTo=' + this.docDateTo +
          //   '&Status0=' + this.Status0 + '&Status1=' + this.Status1 + '&Status2=' + this.Status2 +
          //   '&Status3=' + this.Status3 + '&ReqClinicID=' + this.curRecordReqClinic.ReqClinicID)
          // console.log('After get by Cond..')
          // console.log(resp.data.response)
          this.datalistsROInReqClinic = resp.data.response
          if (this.datalistsROInReqClinic == null) {
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล : RO in Clinic', showConfirmButton: false, timer: 1000 })
            this.datalistsROInReqClinic = []
          }
        //   this.$nextTick(() => {
        //     $('#myROReqClinicTable').DataTable()
        //   })
          // setTimeout(function () { $('#myRepLabStatusTable').DataTable() }, 0)
          // this.countRefresh++
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
